exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body .loading {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\nbody .loading .load {\n  width: 60px;\n  height: 60px;\n  overflow: hidden;\n  float: left;\n  border-radius: 100%;\n  margin-right: 10px;\n}\nbody .loading .load img {\n  max-width: 100%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/contact/contact-infos/contact-infos.component.less
// module id = ../../../../../src/app/contact/contact-infos/contact-infos.component.less
// module chunks = main